pnk-checkbox {
    /* Component styles go here */
}
